export default __webpack_public_path__ + "static/media/navigation.52505d17.png";